import { registerSW } from "virtual:pwa-register";

/**
 * Service-worker registration. Wird von main.tsx nur in PROD aufgerufen
 * (vite.config.ts hat devOptions.enabled=false → dev läuft ohne SW).
 *
 * Strategy:
 *  - registerType: 'prompt' (siehe vite.config) → kein silent skipWaiting
 *  - Wir merken uns die updateSW-funktion in window-scope, damit der
 *    UpdateAvailableToast sie aufrufen kann ("App aktualisieren"-button)
 *  - onOfflineReady: einmaliger toast "App offline-bereit"
 */

declare global {
  interface Window {
    __hpUpdateSW?: (reloadPage?: boolean) => Promise<void>;
    __hpSWReady?: boolean;
    __hpSWNeedsUpdate?: boolean;
  }
}

export function registerServiceWorker(): void {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      window.__hpSWNeedsUpdate = true;
      window.dispatchEvent(new CustomEvent("hitzeprotokoll:sw-update"));
    },
    onOfflineReady() {
      window.__hpSWReady = true;
      window.dispatchEvent(new CustomEvent("hitzeprotokoll:sw-ready"));
    },
    onRegisterError(err) {
      console.warn("[sw] register failed", err);
    },
  });
  window.__hpUpdateSW = updateSW;
}

/**
 * Komplett-unregister + reload. Wird vom settings-route "Alle lokalen
 * Daten löschen"-handler aufgerufen, NACHDEM dexie + caches gewiped sind.
 */
export async function unregisterServiceWorker(): Promise<void> {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((r) => r.unregister()));
}
